module.exports = __webpack_public_path__ + "img/bay-resort-2.d7e46fce.jpg";